import { render, staticRenderFns } from "./company_detail_form.vue?vue&type=template&id=89023b36&scoped=true"
import script from "./company_detail_form.vue?vue&type=script&lang=ts"
export * from "./company_detail_form.vue?vue&type=script&lang=ts"
import style0 from "./company_detail_form.vue?vue&type=style&index=0&id=89023b36&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89023b36",
  null
  
)

export default component.exports